// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2XzuY","boxTitle":"Qualiphy_boxTitle__aIBKw","box":"Qualiphy_box__aXMWr","toggleWrap":"Qualiphy_toggleWrap__1lMpU"};